import useOptimizely from './useOptimizely';
import { ReactSDKClient } from '@optimizely/react-sdk';

export const useMobileMapViewButton = (optimizely: ReactSDKClient | null) => {
    const isExperimentActive = useOptimizely(
        optimizely,
        'sr_796_map_view_button_on_mobile_lsrp'
    );

    return isExperimentActive;
};
